/**
 * Browser Supabase client. Types come from generated `./types` (run `bun run db:gen-types`).
 *
 * `import { supabase } from "@/integrations/supabase/client"`
 *
 * Public customer flows set `x-restaurant-id` via {@link setPublicRestaurantAnonScope} so RLS
 * policies using `request_restaurant_id()` can scope anon reads/writes to one tenant.
 */
import { createClient } from "@supabase/supabase-js";
import { env } from "@/config";
import type { Database } from "./types";

const RESTAURANT_HEADER = "x-restaurant-id";

let publicAnonRestaurantId: string | null = null;

/** Scoped anon tenant for `/order/:slug`, booking, gift, etc. Cleared on `null`. */
export function setPublicRestaurantAnonScope(
  restaurantId: string | null
): void {
  publicAnonRestaurantId = restaurantId;
}

export function getPublicRestaurantAnonScope(): string | null {
  return publicAnonRestaurantId;
}

const supabaseFetch: typeof fetch = (input, init) => {
  const headers = new Headers(init?.headers);
  if (publicAnonRestaurantId) {
    headers.set(RESTAURANT_HEADER, publicAnonRestaurantId);
  }
  return fetch(input, { ...init, headers });
};

export const supabase = createClient<Database>(
  env.supabaseUrl,
  env.supabaseAnonKey,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      fetch: supabaseFetch,
    },
  }
);
